
function updateTotals() {
    $(".js-custom-radio").on('click', function(){
        var $this = $(this);
        var id = $this.data('id');

        var totalProductsTTC = $("#js-total-products").data('price-ttc');
        var totalProductsHT = $("#js-total-products").data('price-ht');
        var totalProductsTVA = $("#js-total-products").data('tva');
        
        var shippingCostTTC = $("#js-shipping-cost-" + id).data('price-ttc');
        var shippingCostHT = $("#js-shipping-cost-" + id).data('price-ht');
        var shippingCostTVA = $("#js-shipping-cost-" + id).data('tva');

        var totalTTC = parseFloat(shippingCostTTC.toString().replace(',', '.')) + parseFloat(totalProductsTTC.toString().replace(',', '.'));
        var totalHT = parseFloat(shippingCostHT.toString().replace(',', '.')) + parseFloat(totalProductsHT.toString().replace(',', '.'));
        var totalTVA = parseFloat(shippingCostTVA.toString().replace(',', '.')) + parseFloat(totalProductsTVA.toString().replace(',', '.'));

        $("#js-add-shipping-ttc-cost").html(totalTTC.toFixed(2).replace('.', ',') + "€");
        $("#js-add-shipping-ht-cost").html(totalHT.toFixed(2).replace('.', ',') + "€");
        $("#js-add-shipping-tva-cost").html(totalTVA.toFixed(2).replace('.', ',') + "€");
    });
}


$(function(){

    if ($('#js-add-shipping-ttc-cost').length) {
        updateTotals();
    }

});
